<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>Abertura de Pré-Matrículas</h1>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <div class="d-flex mb-2 justify-space-between">
          <v-btn color="primary" @click="abrirModalCriar" class="mr-2">
            <v-icon left>mdi-plus</v-icon>
            Nova Abertura de Pré-matriculas
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="aberturas"
              :loading="loading"
              no-data-text="Nenhuma abertura cadastrada"
              class="elevation-1"
            >
              <template v-slot:item.ano="{ item }">
                {{ item.ano ? item.ano.descricao : "-" }}
              </template>

              <template v-slot:item.data_abertura="{ item }">
                {{ formatarData(item.data_abertura) }}
              </template>

              <template v-slot:item.data_fechamento="{ item }">
                {{ formatarData(item.data_fechamento) }}
              </template>

              <template v-slot:item.acoes="{ item }">
                <v-btn icon small @click="abrirModalEditar(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon small @click="confirmarExclusao(item)" color="error">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogForm" max-width="600" persistent>
      <v-card :key="dialogKey">
        <v-card-title class="headline">
          {{ modoEdicao ? "Editar Abertura" : "Nova Abertura" }}
        </v-card-title>
        <v-card-text>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(salvar)">
              <v-row>
                <v-col cols="12">
                  <ValidationProvider name="Ano" rules="required" v-slot="{ errors }">
                    <e-label>Ano Letivo</e-label>
                    <v-select
                      v-model="form.ano_id"
                      :items="anos"
                      item-text="descricao"
                      item-value="id"
                      :error-messages="errors"
                      :disabled="modoEdicao"
                      dense
                      solo
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="6">
                  <ValidationProvider name="Data de Abertura" rules="required" v-slot="{ errors }">
                    <e-label>Data de Abertura</e-label>
                    <e-date-picker
                      v-model="form.data_abertura"
                      :error-messages="errors"
                      placeholder="dd/mm/yyyy"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="6">
                  <ValidationProvider
                    name="Data de Fechamento"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <e-label>Data de Fechamento</e-label>
                    <e-date-picker
                      v-model="form.data_fechamento"
                      :error-messages="errors"
                      placeholder="dd/mm/yyyy"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
            </form>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="fecharDialog">Cancelar</v-btn>
          <v-btn color="primary" :loading="salvando" :disabled="!formularioValido" @click="salvar">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmar Exclusão</v-card-title>
        <v-card-text> Tem certeza que deseja excluir esta abertura de pré-matrícula? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogExcluir = false">Cancelar</v-btn>
          <v-btn color="error" text @click="excluir" :loading="loading">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="custom-toast-container">
      <transition-group name="toast-slide" tag="div">
        <v-snackbar
          v-for="(toast, index) in toastStack"
          :key="toast.id"
          v-model="toast.show"
          :color="toast.color"
          :timeout="0"
          :style="{ bottom: `${index * 80 + 16}px` }"
          class="custom-toast"
          bottom
          elevation="6"
        >
          <div class="d-flex align-center">
            <v-icon class="toast-icon mr-3">
              {{ toast.color === "error" ? "mdi-alert-circle" : "mdi-check-circle" }}
            </v-icon>
            <span class="toast-message">{{ toast.message }}</span>
          </div>
          <template v-slot:action="{ attrs }">
            <v-btn icon small v-bind="attrs" @click="removeToast(toast.id)" class="toast-close">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </transition-group>
    </div>
  </main-template>
</template>

<script>
export default {
  name: "AberturaPreMatriculasPage",
  data() {
    return {
      aberturas: [],
      anos: [],
      loading: false,
      salvando: false,
      dialogForm: false,
      dialogExcluir: false,
      dialogKey: 0,
      modoEdicao: false,
      aberturaSelecionada: null,
      form: {
        ano_id: null,
        data_abertura: null,
        data_fechamento: null,
      },
      headers: [
        { text: "Ano Letivo", value: "ano" },
        { text: "Data Abertura", value: "data_abertura" },
        { text: "Data Fechamento", value: "data_fechamento" },
        { text: "Ações", value: "acoes", sortable: false },
      ],
      toastStack: [],
      toastIdCounter: 0,
    };
  },

  computed: {
    formularioValido() {
      return (
        this.form.ano_id !== null &&
        this.form.data_abertura !== null &&
        this.form.data_abertura !== "" &&
        this.form.data_fechamento !== null &&
        this.form.data_fechamento !== ""
      );
    },
  },

  methods: {
    showCustomToast(message, color = "error", timeout = 5000) {
      const id = ++this.toastIdCounter;
      const toast = {
        id,
        message,
        color,
        timeout,
        show: true,
      };

      this.toastStack.push(toast);
      setTimeout(() => {
        this.removeToast(id);
      }, timeout);
    },

    removeToast(id) {
      const index = this.toastStack.findIndex((t) => t.id === id);
      if (index !== -1) {
        this.toastStack.splice(index, 1);
      }
    },

    formatarData(value) {
      if (!value) return "-";

      const d = value instanceof Date ? value : new Date(value);
      if (isNaN(d)) return "-";

      return d.toLocaleDateString("pt-BR");
    },

    dateToYMD(date) {
      if (!date) return null;
      const d = new Date(date);
      return d.toISOString().split("T")[0];
    },

    async listarAberturas() {
      this.loading = true;
      try {
        const response = await this.$services.aberturaPreMatriculasService.listar();
        this.aberturas = Array.isArray(response) ? response : response?.data || [];
      } catch (error) {
        this.$toast.danger(error.message || "Erro ao carregar aberturas");
      } finally {
        this.loading = false;
      }
    },

    async listarAnos() {
      try {
        const response = await this.$services.aberturaPreMatriculasService.listarAnos();
        this.anos = Array.isArray(response) ? response : response?.data || [];
      } catch (error) {
        this.$toast.danger(error.message || "Erro ao carregar anos");
      }
    },

    abrirModalCriar() {
      this.modoEdicao = false;
      this.aberturaSelecionada = null;
      this.form = {
        ano_id: null,
        data_abertura: null,
        data_fechamento: null,
      };
      this.dialogKey++;
      this.dialogForm = true;
    },

    abrirModalEditar(abertura) {
      this.modoEdicao = true;
      this.aberturaSelecionada = abertura;
      this.form = {
        ano_id: abertura.ano_id,
        data_abertura: this.dateToYMD(abertura.data_abertura),
        data_fechamento: this.dateToYMD(abertura.data_fechamento),
      };
      this.dialogKey++;
      this.dialogForm = true;
    },

    fecharDialog() {
      this.dialogForm = false;
      this.aberturaSelecionada = null;
    },

    async salvar() {
      this.salvando = true;
      try {
        const payload = {
          ano_id: this.form.ano_id,
          data_abertura: this.dateToYMD(this.form.data_abertura),
          data_fechamento: this.dateToYMD(this.form.data_fechamento),
        };

        if (this.modoEdicao) {
          await this.$services.aberturaPreMatriculasService.atualizar(
            this.aberturaSelecionada.id,
            payload
          );

          this.$toast.success("Abertura atualizada com sucesso!");
        } else {
          await this.$services.aberturaPreMatriculasService.criar(payload);
          this.$toast.success("Abertura criada com sucesso!");
        }

        this.fecharDialog();
        this.listarAberturas();
      } catch (error) {
        if (error.errors) {
          const errorMessages = [];
          Object.values(error.errors).forEach((errorArray) => {
            if (Array.isArray(errorArray)) {
              errorMessages.push(...errorArray);
            } else {
              errorMessages.push(errorArray);
            }
          });
          errorMessages.forEach((message) => {
            this.showCustomToast(message, "error", 6000);
          });
        } else {
          this.showCustomToast(error.message || "Erro ao salvar abertura", "error", 6000);
        }
      } finally {
        this.salvando = false;
      }
    },

    confirmarExclusao(abertura) {
      this.aberturaSelecionada = abertura;
      this.dialogExcluir = true;
    },

    async excluir() {
      this.loading = true;
      try {
        await this.$services.aberturaPreMatriculasService.excluir(this.aberturaSelecionada.id);
        this.$toast.success("Abertura excluída com sucesso!");
        this.dialogExcluir = false;
        this.listarAberturas();
      } catch (error) {
        this.$toast.danger(error.message || "Erro ao excluir abertura");
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.listarAberturas();
    this.listarAnos();
  },
};
</script>

<style scoped>
.custom-toast-container {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  pointer-events: none;
}

.custom-toast {
  position: fixed !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin-bottom: 0 !important;
  pointer-events: auto;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Animação de entrada - sobe de baixo com fade */
.toast-slide-enter-active {
  animation: toast-slide-in 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* Animação de saída - desce para baixo com fade */
.toast-slide-leave-active {
  animation: toast-slide-out 0.4s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

/* Animação de movimento quando outros toasts são removidos */
.toast-slide-move {
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

@keyframes toast-slide-in {
  0% {
    transform: translateX(-50%) translateY(150%) scale(0.9);
    opacity: 0;
  }
  60% {
    transform: translateX(-50%) translateY(-5%) scale(1.02);
  }
  100% {
    transform: translateX(-50%) translateY(0) scale(1);
    opacity: 1;
  }
}

@keyframes toast-slide-out {
  0% {
    transform: translateX(-50%) translateY(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(150%) scale(0.9);
    opacity: 0;
  }
}

/* Ícone do toast com animação de pulso */
.toast-icon {
  animation: toast-icon-pulse 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
}

@keyframes toast-icon-pulse {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Mensagem do toast */
.toast-message {
  font-weight: 500;
  line-height: 1.4;
}

/* Botão de fechar */
.toast-close {
  opacity: 0.8;
  transition: opacity 0.3s ease, transform 0.2s ease;
}

.toast-close:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* Sombra suave nos toasts */
.custom-toast ::v-deep .v-snack__wrapper {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-width: 600px;
  max-width: 800px;
  margin: 0 auto;
  left: 0 !important;
  right: 0 !important;
}

.custom-toast ::v-deep .v-snack__content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 16px;
  padding-right: 16px;
  justify-content: flex-start;
}

/* Efeito hover no toast */
.custom-toast ::v-deep .v-snack__wrapper:hover {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}
</style>
